import { useHttp } from '@d5/hooks'
import { ID5MetaType } from '@d5/ui'

import {
  ExistingStoreFormData,
  NewOrderFormData,
  StoreNewStoreFormData,
  StoresTableColumn,
} from '@/types'

interface StoresListReqeustParams {
  offset: number
  limit: number
  store_id?: string | number
  store_hash?: string
  account_name?: string
  plan?: number | string
  status?: number | string
  expire_time_start_at?: string | number
  expire_time_due_at?: string | number
  sort_by?: string
  order_by?: string
  account?: string
  account_id?: string
  search?: string
  platform_type?: string
}

interface ShopifyAuthUrlStoreConnectType {
  url: string
}

export const useStoresList = (data: StoresListReqeustParams) =>
  useHttp<{ data: Array<StoresTableColumn>; meta: ID5MetaType }>({
    url: '/stores',
    data,
  })

export const useStoreAddition = (data: StoreNewStoreFormData) =>
  useHttp<{
    data: object
    meta: ID5MetaType
  }>({
    url: '/stores',
    method: 'post',
    data,
  })

export const useStorePaused = (id: string | number) =>
  useHttp<{
    data: object
    meta: ID5MetaType
  }>({
    url: `/stores/${id}/pause`,
    method: 'post',
  })

interface StoreDestoryedRequestParams {
  id: string
  store_id: string
  confirm: string
}

export const useStoreDestroyed = (data: StoreDestoryedRequestParams) =>
  useHttp<{
    data: object
    meta: ID5MetaType
  }>({
    url: `/stores/${data?.id}/destroy`,
    method: 'post',
    data: {
      store_id: data?.store_id,
      confirm: data?.confirm,
    },
  })

export const useStoreUpdate = (data: NewOrderFormData) =>
  useHttp<{ data: object; meta: ID5MetaType }>({
    url: `/stores/${data?.id}/change-plan`,
    method: 'post',
    data: {
      cur_plan: data.cur_plan,
      effective: data.effective,
    },
  })

export const useLoginToStore = (id: string) =>
  useHttp<{
    data: {
      login_url: string
    }
    meta: ID5MetaType
  }>({
    url: `/stores/${id}/login`,
    method: 'post',
  })

export const useStoreConnect = (data: Partial<ExistingStoreFormData>) =>
  useHttp<{
    data: object
    meta: ID5MetaType
  }>({
    url: '/stores/connect',
    method: 'post',
    data,
  })

export const useShopifyAuthUrlStoreConnect = () =>
  useHttp<{
    data: ShopifyAuthUrlStoreConnectType
    meta: ID5MetaType
  }>({
    url: '/stores/shopify/auth-url',
    method: 'get',
  })
